module.exports = ":host {\n  height: 100%;\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/vocabulary/components/value-set-tile.component.scss
// module id = ./src/app/vocabulary/components/value-set-tile.component.scss
// module chunks = main